import Box from '@mui/material/Box';

export default function WarningErrorIcon({ state }) {
  return (
    state !== null &&
    state !== undefined && (
      <>
        {state ? (
          <Box
            component="span"
            sx={(theme) => ({
              ml: theme.fuel6Tokens.JddcSpacingSmall,
              color: theme.fuel6Tokens.JddcColorIconWarning,
              display: 'inline-flex'
            })}
          >
            <fuel-icon name="error_outlined" />
          </Box>
        ) : (
          <Box
            component="span"
            sx={(theme) => ({
              ml: theme.fuel6Tokens.JddcSpacingSmall,
              color: 'error.main',
              display: 'inline-flex'
            })}
          >
            <fuel-icon name="error" />
          </Box>
        )}
      </>
    )
  );
}
